angular.module('impactx.productcoding').controller('ProductGroupEditDialogCtrl', ['$scope', '$mdDialog', 'TranslationService',
    'themeFactory', 'dataGen', 'ToastService',
    ProductGroupEditDialogCtrl]);

function ProductGroupEditDialogCtrl($scope, $mdDialog, TranslationService, themeFactory, dataGen, ToastService)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.deleteLabel = TranslationService.get("delete");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.closeLabel = TranslationService.get("close");
    $scope.theme = themeFactory.getTheme();

    var self = this;
    self.requestInProgress = false;

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.save = function() {
        self.requestInProgress = true;
        dataGen.postAsForm($scope, {data: $scope.data}, "/productgroup/save").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $mdDialog.hide();
        }).finally(function () {
            self.requestInProgress = false;
        });
    };

    dataGen.getData($scope, {catId: self.catId, vcatId: self.vcatId, prgId: self.prgId, superPrgId: self.superPrgId}, "/productgroup/view");
}